import { ELinks } from '@sharedInterfaces/globalEnums';
import { EIconCategory } from '@src/helper/iconRegistry';
import type Employee from '@src/Objects/Employee';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import FeatureCardWidget from './FeatureCardWidget';

interface SkillManagerCardWidgetProps {
    employee: Employee;
    onTabChange: (tabIndex: number) => void;
}

function SkillManagerCardWidget({ employee, onTabChange }: SkillManagerCardWidgetProps) {
    const navigate = useNavigate();

    return (
        <FeatureCardWidget
            title="Skill Manager"
            description="Verwalte deine Skills und schließe Kompetenzlücken. Analysiere deine Fähigkeiten und entwickle gezielt neue Skills für deine Karriere."
            imagePath="/img/t4lo_skillmanager.png"
            iconCategory={EIconCategory.SKILLS}
            onClick={() => onTabChange(5)}
        />
    );
}

export default SkillManagerCardWidget;
